import React from 'react';
import { useDispatch } from 'react-redux';
import { setReleaseNotesVisible } from '../actions/layout';
import { APP_VERSION, APP_VERSION_D } from '../config';
// import closeImg from '../static/icon-x.png';
import logoImg from '../static/logo.svg';
import styles from './ReleaseNotes.module.less';
import { cacheKeys } from '../constants/storageKeys';

const ReleaseNotes = () => {
  const dispatch = useDispatch();
  const startInfoStr = localStorage.getItem(cacheKeys.START_INFO);
  const startInfo = JSON.parse(startInfoStr || '{}');
  return (
    <div className={styles.ReleaseNotes}>
      <span
        className="icon close"
        onClick={() => {
          dispatch(setReleaseNotesVisible(false));
        }}
      >
        <i className="iconfont icon-close" />
      </span>
      <div className="top">
        <img src={logoImg} alt="" className="logo" />
        联想软件商店
      </div>
      <div className="header">
        <div className="title">版本特性与功能</div>
      </div>
      <div className="cont">
        <div className="ver">
          <span className="name">版本：</span>
          <span className="val">{startInfo.isDStore ? APP_VERSION_D : APP_VERSION}</span>
        </div>
        <div className="list">
          <div className="item">
            <span className="num">1.</span>
            <span className="text">教育频道全新改版，上千节免费课程随时学！</span>
          </div>
          <div className="item">
            <span className="num">2.</span>
            <span className="text">下载优化，下载成功率up！up！up！</span>
          </div>
          <div className="item">
            <span className="num">3.</span>
            <span className="text">游戏频道全面改版， 快来感受和体验! </span>
          </div>
          <div className="item">
            <span className="num">4.</span>
            <span className="text">更多新功能，等你探索和发现~</span>
          </div>
          {/* <div className="item">
            <span className="num">5.</span>
            <span className="text">更多新功能，等你探索和发现~</span>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ReleaseNotes;
